import { InjectionToken } from '@angular/core';
import { MaintenanceOption } from './models/maintenance-option';

export const MAINTENANCE_OPTION = new InjectionToken<MaintenanceOption>(
  'MAINTENANCE_OPTION'
);
